import React from 'react';
import { Chip } from '@mui/material';

const statusColors = {
  open: { color: 'info', label: 'Abierto' },
  in_progress: { color: 'warning', label: 'En Progreso' },
  resolved: { color: 'success', label: 'Resuelto' },
  escalated: { color: 'warning', label: 'Escalado' },
  closed: { color: 'default', label: 'Cerrado' },
  active: { color: 'success', label: 'Activo' },
  inactive: { color: 'default', label: 'Inactivo' },
  testing: { color: 'info', label: 'Prueba' },
  pending: { color: 'warning', label: 'Pendiente' },
  pendiente: { color: 'warning', label: 'Pendiente' },
  validado: { color: 'success', label: 'Validado' },
  rechazado: { color: 'error', label: 'Rechazado' },
  enviado: { color: 'info', label: 'Enviado' },
  entregado: { color: 'success', label: 'Entregado' },
  leido: { color: 'success', label: 'Leído' },
  read: { color: 'success', label: 'Leído' },
  completada: { color: 'success', label: 'Completada' },
  completed: { color: 'success', label: 'Completada' },
  fallido: { color: 'error', label: 'Fallido' },
  failed: { color: 'error', label: 'Fallido' },
  high: { color: 'error', label: 'Alto' },
  medium: { color: 'warning', label: 'Medio' },
  low: { color: 'info', label: 'Bajo' },
};

export const StatusBadge = ({ status, size = 'small' }) => {
  const statusConfig = statusColors[status] || { color: 'default', label: status };

  return (
    <Chip
      label={statusConfig.label}
      color={statusConfig.color}
      size={size}
      sx={{ textTransform: 'capitalize' }}
    />
  );
};

